import React from "react";
import PropTypes from "prop-types";

const AthenaMindIcon = ({ className, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Antena */}
    <line x1="12" y1="2" x2="12" y2="5" />
    <circle cx="12" cy="2" r="0.5" fill="currentColor" stroke="none" />

    {/* Cabeza del Robot */}
    <rect x="4" y="5" width="16" height="13" rx="3" />

    {/* Ojos y Boca */}
    <circle cx="8.5" cy="10.5" r="0.8" fill="currentColor" stroke="none" />
    <circle cx="15.5" cy="10.5" r="0.8" fill="currentColor" stroke="none" />
    <path d="M 9 14.5 Q 12 16 15 14.5" />

    {/* Detalles laterales (sensores) */}
    <line x1="2" y1="10" x2="4" y2="10" />
    <line x1="20" y1="10" x2="22" y2="10" />

    {/* Base/Cuello */}
    <line x1="9" y1="21" x2="15" y2="21" />
    <line x1="12" y1="18" x2="12" y2="21" />
  </svg>
);

export default AthenaMindIcon;

AthenaMindIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
};

AthenaMindIcon.defaultProps = {
  className: "",
  size: 22,
};
